import { addClassNamesToElement } from "@lexical/utils";
import {
    $applyNodeReplacement,
    DOMExportOutput,
    EditorConfig,
    LexicalEditor,
    LexicalNode,
    SerializedTextNode,
    TextNode,
} from "lexical";

const CUSTOM_VARIABLE_NODE_TYPE = "custom-variable-node";

type SerializedCustomVariableNode = SerializedTextNode;

export class CustomVariableNode extends TextNode {
    static getType(): string {
        return CUSTOM_VARIABLE_NODE_TYPE;
    }

    static clone(node: CustomVariableNode): CustomVariableNode {
        return new CustomVariableNode(node.__text, node.__key);
    }

    static importJSON(serializedNode: SerializedTextNode): CustomVariableNode {
        const node = $createCustomVariableNode(serializedNode.text);
        node.setStyle(serializedNode.style);
        return node;
    }

    createDOM(config: EditorConfig): HTMLElement {
        const element = super.createDOM(config);
        addClassNamesToElement(element, config.theme.customVariable);
        return element;
    }

    exportDOM(editor: LexicalEditor): DOMExportOutput {
        const { element } = super.exportDOM(editor);
        // we don't want to highlight in purple the values
        // of the custom variables, just the variable names
        // so we remove the `class` attribute from the node
        // when we serialize this node to an HTML preview
        (element as HTMLElement).removeAttribute("class");
        return { element };
    }

    exportJSON(): SerializedCustomVariableNode {
        return {
            ...super.exportJSON(),
            type: CUSTOM_VARIABLE_NODE_TYPE,
        };
    }

    canInsertTextBefore(): boolean {
        return false;
    }

    canInsertTextAfter(): boolean {
        return false;
    }

    supportsAutocomplete(): boolean {
        return true;
    }
}

export function $createCustomVariableNode(text: string): CustomVariableNode {
    const customVariableNode = new CustomVariableNode(text);
    return $applyNodeReplacement(customVariableNode);
}

export function $isCustomVariableNode(node: LexicalNode | null | undefined): node is CustomVariableNode {
    return node instanceof CustomVariableNode;
}
